import { withNamespaces } from "react-i18next";
import Accordion from 'react-bootstrap/Accordion';
import ShareholdersImage from "src/modules/3rd-party-management/assets/images/shareholders.svg";
import { Table } from "reactstrap";
import {
    formatMoney,
    hasNonEmptyArray,
    parseHandelsregisterOrganizationData
} from "../../helpers";

const formatShareholderName = (entry) => {
    const s = entry?.shareholder || {};
    if (s.name) {
        return s.name;
    }
    const person = [s.first_name, s.last_name].filter(Boolean).join(' ');
    return person || '-';
};

const formatRatio = (ratio) => {
    if (ratio === null || ratio === undefined || ratio === '') {
        return '-';
    }
    const num = Number(ratio);
    if (Number.isNaN(num)) {
        return String(ratio);
    }
    // API returns fraction (e.g. 0.00452)
    const pct = num <= 1 ? num * 100 : num;
    return `${pct.toFixed(2)}%`;
};

const Shareholders = ({
    t,
    activeAccordion,
    setActiveAccordion,
    detailsQuery
}) => {
    const data = parseHandelsregisterOrganizationData(detailsQuery?.data?.company);
    const entries = data?.shareholders?.entries || [];

    if (!hasNonEmptyArray(entries)) {
        return null;
    }

    const totalCapital = data.shareholders.total_capital;

    return (
        <Accordion.Item
            onClick={() => setActiveAccordion('shareholders')}
            className={activeAccordion === 'shareholders' ? 'active' : ''}
            eventKey={'shareholders'}
        >
            <Accordion.Header>
                <img src={ShareholdersImage} alt="" />
                <span>{t('Shareholders')}</span>
            </Accordion.Header>

            <Accordion.Body>
                {totalCapital && (
                    <p className="mb-3">
                        <strong>{t('Total Capital')}:</strong>{' '}
                        {formatMoney(totalCapital.amount, totalCapital.currency)}
                    </p>
                )}
                <div className="table-responsive">
                    <Table bordered hover striped size="sm" className="mb-0">
                        <thead>
                            <tr>
                                <th>{t('Name')}</th>
                                <th>{t('Role')}</th>
                                <th>{t('Contribution')}</th>
                                <th>{t('Ownership')}</th>
                                <th>{t('Address')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {entries.map((entry, index) => (
                                <tr key={entry?.shareholder?.entity_id || index}>
                                    <td>{formatShareholderName(entry)}</td>
                                    <td>
                                        {entry?.role?.en?.long ||
                                            entry?.role?.de?.long ||
                                            entry?.role?.label ||
                                            '-'}
                                    </td>
                                    <td>
                                        {entry?.contribution
                                            ? formatMoney(entry.contribution.amount, entry.contribution.currency)
                                            : '-'}
                                    </td>
                                    <td>{formatRatio(entry?.contribution_ratio)}</td>
                                    <td>
                                        {typeof entry?.shareholder?.address === 'string'
                                            ? entry.shareholder.address
                                            : '-'}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>
            </Accordion.Body>
        </Accordion.Item>
    );
};

export default withNamespaces()(Shareholders);
